var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtrasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 0.6L6.35 4.05L9.8 5.2L6.35 6.35L5.2 9.8L4.05 6.35L0.6 5.2L4.05 4.05L5.2 0.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 7.6L10.98 9.02L12.4 9.6L10.98 10.18L10.4 11.6L9.82 10.18L8.4 9.6L9.82 9.02L10.4 7.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtrasIcon);
export default __webpack_public_path__ + "static/media/ExtrasIcon.c6d4c860051efaaa15c5351ff776acdc.svg";
export { ForwardRef as ReactComponent };